<template>
<div>
  <div class="row">
      <div class="col-md-12 card">
          <div class="card-header">
            <div class="row">
               <div class="col-md-5">
                  <h3 class="title">{{ $t('reports') }} <span style="color: #FDCB6A">|</span>{{ $t('soil_scans') }}</h3>
               </div>
               <div class="col-md-2">
                 <fg-input>
                    <el-select size="large" @change="soilCareFilter" class="select-primary" v-model="form.year" filterable clearable :placeholder="$t('select_year')">
                        <el-button @click.prevent="getReportSearch('year')"  style="width:100%; border:none">{{ $t('all')}}</el-button>
                        <el-option
                          class="select-primary"
                          v-for="year in years"
                          :key="year"
                          :label="year"
                          :value="year"></el-option>
                    </el-select>
                 </fg-input>
               </div>
               <div class="col-md-3">
                 <fg-input>
                    <el-select size="large" @change="soilCareFilter" class="select-primary" v-model="form.countryID" filterable clearable :placeholder="$t('select_country')">
                        <el-button @click.prevent="getReportSearch('country')"  style="width:100%; border:none">{{ $t('all') }}</el-button>
                        <el-option
                          class="select-primary"
                          v-for="country in Countries"
                          :key="country.id"
                          :label="country.name"
                          :value="country.name"></el-option>
                    </el-select>
                 </fg-input>
               </div>
               <div class="col-md-2">
                  <fg-input>
                      <el-select size="large" @change="soilCareFilter" class="select-primary" v-model="form.ngoID" value-key="0" filterable clearable :placeholder="$t('select_ngo')">
                          <el-button @click.prevent="getReportSearch('ngo')" style="width:100%; border:none">{{$t('all')}}</el-button>
                          <el-option
                            class="select-primary"
                            v-for="ngo in NGO"
                            :key="ngo.id"
                            :label="ngo.name"
                            :value="ngo.name"></el-option>
                      </el-select>
                  </fg-input>
               </div>
            </div>
          </div>
          <div class="card-body" v-loading="loading" :element-loading-text="$t('loading_data')+'...'">
             <div class="col-md-12" v-if="activityChart.data.labels.length > 0">
                <chart-card
                     :chart-data="activityChart.data"
                      :chart-height="130"
                      chart-id="activity-bar-chart"
                      chart-type="Bar">
                </chart-card>
              </div>
          </div>
      </div>
  </div>
  <div class="row mt-4">
      <div class="navBottom pull-right">
        <p-button class="btn btn-deepDark" @click.prevent="goToShowSoilList()">
            <span>{{$t('show_list')}}</span> <i class="fa fa-list" style="padding-left:15px"></i>
        </p-button>
        <p-button class="btn btn-yellow" @click.prevent="goToShowSoilMap()">
            <span>{{$t('show_map')}}</span> <i class="fa fa-map-marker fa-lg" style="padding-left:15px"></i>
        </p-button>
      </div>
    </div>
  </div>
</template>
<script>
import ChartCard from 'src/components/UIComponents/Cards/ChartCard';
import Resource from "@/util/Api/resource.js";
import { Message, Form } from "element-ui";
const NGOResources = new Resource("category/childrenGivenParent");
const SoilResource = new Resource("soilcare/allFields");
const soilFilterResource = new Resource("soilcare");
const orders =  new Resource('soilcare/allOrders');

export default {
  components: {
    ChartCard,
  },
  data() {
    return {
        loading:false,
        NGO:[],
        Countries:[],
        years:[],
        allMonth:[],
        soilScans:[],
        filteredSoilCare:[],
        posts:[],
        createdDates:[],
        actualData:[],
        actualSoilData:{
          month:'',
          count:0,
          year:'',
        },
        soilData:{
          month:'',
          count:0,
          year:'',
        },
        form:{
          countryID:'',
          ngoID:'',
          year:'',
        },
        activityChart: {
          data: {
            labels: [],
            datasets: [
              {
                label: this.$t("data"),
                borderColor: '#000000',
                fill: true,
                backgroundColor: '#000000',
                hoverBorderColor: '#FDC353',
                borderWidth: 2,
                data: [],
              },
            ]
          }
        },
    }
  },

  methods: {

    // Show message pop up
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    // Get all NGOs in a categories
    async getNGOs() {
      await NGOResources.get(1).then(response => {
        this.NGO = response.data;
      }).catch(error => {
         console.log('Failed getting NGO data')
      });
    },

    // Get all countries in a category
    async getCountry() {
      await NGOResources.get(2).then(response => {
        this.Countries = response.data;
      }).catch(error => {
         console.log('Failed getting all country data')
      });
    },

    // get year range
    getYear(){
       let currentYear = new Date().getFullYear();
       let startYear = 2016;
       for(var i=startYear; i <= currentYear; i++){
          this.years.push(startYear++);
       }
       this.years.reverse();
    },

    // showing soil list
    goToShowSoilList(){
       this.$router.push({ name: "ShowList" });
    },

    // showing soil list
    goToShowSoilMap(){
       this.$router.push({ name: "ShowMap" });
    },

    // get date month
    getDateMonth(date){
        let mlist = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let month = mlist[date.getMonth()];
        let obj = {};
        obj = {
          month: month,
          year: date.getFullYear()
        }
        return obj;
    },

    // get year from data
    getDateYear(date){
       let year = date.getFullYear();
       return year;
    },

    // counting
    getOccurrence(array, value, year) {
        var count = 0;
        array.forEach((v) => {
          if(v.month === value && v.year === year){
            count++;
          }
        });
        return count;
    },

    // order by month
    orderMonth(a, b) {
      const bandA = a.month;
      const bandB = b.month;
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },

    // order by year
    orderYear(a, b) {
      const bandA = a.year;
      const bandB = b.year;
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },

    // sort by month
    sortByMonth(a, b) {
      let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return months.indexOf(a.month) - months.indexOf(b.month);
    },

    // function hitting soilcare filter endpoint
    async soilCareFilter(){

        this.loading = true;
        let cur = null, year = null;
        this.filteredSoilCare = [];
        this.createdDates = [];
        this.soilScans = [];
        this.soilData = {};
        this.activityChart.data.labels = [];
        this.activityChart.data.datasets[0].data = [];

        if(this.form.ngoID === "") {
            this.form.ngoID = 0;
        }

        if(this.form.countryID === ""){
          this.form.countryID = 0;
        }

        if(this.form.year === "") {
          this.form.year = 0;
        }

        await soilFilterResource.report(this.form.countryID, this.form.ngoID, this.form.year)
         .then((response) => {

            this.filteredSoilCare = response.data;

            this.filteredSoilCare.result.forEach((element, key) => {
                 let elements = JSON.parse(element);
                 elements.Pages.forEach((value, index) => {
                    this.createdDates.push(this.getDateMonth(new Date(value.Header.GeneralInformation.AnalyseDate)));
                 });
            });

           //console.log('Not Saerch data',  this.createdDates);

           this.createdDates.sort(this.orderMonth).forEach((value, index) => {
              this.soilData = {};
              if(value.month !== cur){
                 this.soilData.month = value.month;
                 this.soilData.year = value.year;
                 this.soilData.count = this.getOccurrence(this.createdDates, value.month, value.year);
                 this.soilScans.push(this.soilData);
              }
              cur = value.month;
              year = value.year;
           });

          this.soilScans.sort(this.sortByMonth).forEach((element) => {
            this.activityChart.data.labels.push(element.month + " " + element.year);
            this.activityChart.data.datasets[0].data.push(element.count);
          });

         }).catch((error) => {
            console.log(`Error occured getting filtered data ${error}`);
         }).finally(() => {
           this.loading = false;
           if(this.form.ngoID === 0){
            this.form.ngoID = "";
           }

            if(this.form.countryID === 0){
              this.form.countryID = "";
            }

            if(this.form.year === 0) {
              this.form.year = "";
            }
         });

    },


    // query on search purposes
    async getReportSearch(type) {
      this.loading = true;
      let cur = null, year = null;
      this.filteredSoilCare = [];
      this.createdDates = [];
      this.soilScans = [];
      this.soilData = {};
      this.activityChart.data.labels = [];
      this.activityChart.data.datasets[0].data = [];

      if(type === "country") {

          this.form.countryID = 0;
          if(this.form.ngoID === "") {
           this.form.ngoID = 0;
          }
          if(this.form.year === "") {
            this.form.year = 0;
          }

      } else if(type === "ngo"){

          this.form.ngoID = 0;
          if(this.form.countryID === "") {
            this.form.countryID = 0;
          }
          if(this.form.year === "") {
            this.form.year = 0;
          }

      } else if(type === "year"){

          this.form.year = 0;
          if(this.form.countryID === "") {
            this.form.countryID = 0;
          }
          if(this.form.ngoID === "") {
            this.form.ngoID = 0;
          }

      }

      //console.log('form', this.form);

      await soilFilterResource.report(this.form.countryID, this.form.ngoID, this.form.year)
      .then((response) => {
          //console.log('Second', response.data);
          this.filteredSoilCare = response.data;

          this.filteredSoilCare.result.forEach((element, key) => {
                let elements = JSON.parse(element);
                // console.log('element', elements);
                elements.Pages.forEach((value, index) => {
                  this.createdDates.push(this.getDateMonth(new Date(value.Header.GeneralInformation.AnalyseDate)));
                });
          });

          //console.log('Search data',  this.createdDates);

          this.createdDates.sort(this.orderMonth).forEach((value, index) => {
              this.soilData = {};
              if(value.month !== cur){
                 this.soilData.month = value.month;
                 this.soilData.year = value.year;
                 this.soilData.count = this.getOccurrence(this.createdDates, value.month, value.year);
                 this.soilScans.push(this.soilData);
              }
              cur = value.month;
              year = value.year;
           });

          //console.log('Dates', this.soilScans.sort(this.orderYear));

          this.soilScans.sort(this.sortByMonth).forEach((element) => {
             this.activityChart.data.labels.push(element.month + " " + element.year);
             this.activityChart.data.datasets[0].data.push(element.count);
          });

          //console.log('labels', this.activityChart.data.labels);


      }).catch((error) => {
           this.showAlertMessage("Sorry, Internet issues or Requested data does not exist","error");
           console.log(`Error occured getting filtered data ${error}`);
      }).finally(() => {
          this.loading = false;
          if(this.form.ngoID === 0){
            this.form.ngoID = "";
          }

          if(this.form.countryID === 0){
            this.form.countryID = "";
          }

          if(this.form.year === 0) {
            this.form.year = "";
          }

      });

    },

  },

  mounted() {
    this.soilCareFilter();
    this.getYear();
    this.getNGOs();
    this.getCountry();
  },

}
</script>
<style scoped>

  .btn-deepDark {
      background-color: #000000;
      color: white;
      margin-right: 10px;
  }

  .btn-yellow {
     background-color: #FEB936;
     color: #000000;
  }

  .navBottom {
      display: flex;
      position: absolute;
      right: 0;
      width: 330px;
      bottom: 70px;
  }

</style>
